import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import showToast from '../../utils/toast';
import AuthLayout from '../../components/auth/AuthLayout';

const DEMO_RESET_OTP = '123456';

const VerifyOtp = () => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const mobileFromState = location.state?.mobile;
  const storedMobile = localStorage.getItem('resetMobile');
  const storedOtp = localStorage.getItem('resetOtp');
  const mobile = mobileFromState || storedMobile || '';

  useEffect(() => {
    if (!mobile || !storedOtp) {
      navigate('/forgot-password', { replace: true });
    }
  }, [mobile, storedOtp, navigate]);

  const handleChange = (e) => {
    const { value } = e.target;
    const formattedValue = value.replace(/\D/g, '');
    setOtp(formattedValue.slice(0, 6));
    if (error) {
      setError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (otp.length !== 6) {
      setError('Please enter the 6-digit OTP.');
      return;
    }

    setLoading(true);
    setError('');

    const expectedOtp = storedOtp || DEMO_RESET_OTP;

    if (otp !== expectedOtp) {
      const message = 'Invalid OTP. Please try again.';
      setError(message);
      showToast.error(message);
      setLoading(false);
      return;
    }

    showToast.success('OTP verified successfully.');
    navigate('/reset-password', { state: { mobile } });
    setLoading(false);
  };

  const handleBack = () => {
    navigate('/forgot-password');
  };

  return (
    <AuthLayout
      title="Verify OTP"
      subtitle={`Enter the OTP sent to ${mobile ? `+91 ${mobile}` : 'your registered mobile number'}.`}
      onBack={handleBack}
    >
      {error && (
        <div className="toast-error">
          <div className="toast-content">
            <div className="toast-icon">⚠️</div>
            <div className="toast-text">{error}</div>
            <button className="toast-close" onClick={() => setError('')}>
              ×
            </button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">OTP</label>
          <input
            type="text"
            className="form-input"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={handleChange}
            maxLength={6}
            required
          />
        </div>

        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default VerifyOtp;
